document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".table-container");
  const tableBody = document.querySelector(".searchable-table tbody");
  const searchInput = document.querySelector(".table-search-input");

  if (!container || !tableBody) {
    console.error("Device table elements not found.");
    return;
  }

  const jsonUrl = container.dataset.deviceJsonUrl;
  let devices = [];

  fetch(jsonUrl)
    .then(response => {
      if (!response.ok) throw new Error("Network response was not ok");
      return response.json();
    })
    .then(data => {
      if (!Array.isArray(data) || data.length === 0) {
        tableBody.innerHTML = "<tr><td colspan='3'>No devices found</td></tr>";
        return;
      }
      devices = data;
      renderTable(devices);
    })
    .catch(err => {
      console.error("Failed to load device data:", err);
      tableBody.innerHTML = "<tr><td colspan='3'>Unable to load device data</td></tr>";
    });

  function renderTable(data) {
    tableBody.innerHTML = "";

    if (data.length === 0) {
      tableBody.innerHTML = "<tr><td colspan='3'>No matching devices found</td></tr>";
      return;
    }

    data.forEach(device => {
      const row = document.createElement("tr");
      row.innerHTML = `
        <td>${device["device name"]}</td>
        <td>${device["model number"]}</td>
        <td>${device["required action"]}</td>
      `;
      tableBody.appendChild(row);
    });
  }

  searchInput.addEventListener("keyup", function () {
    const value = this.value.toLowerCase();

    const filtered = devices.filter(device =>
      device["model number"].toLowerCase().includes(value) ||
      device["device name"].toLowerCase().includes(value) ||
      device["required action"].toLowerCase().includes(value)
    );

    renderTable(filtered);
  });
});